'use client';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
export const ACTIVATED_DRAW_ID_QUERY_PARAM = 'activatedDrawId';
/**
 * React hook that removes `activatedDrawId` from the URL once that draw has been paid for.
 *
 * @returns Callback taking the activated draw ids that were paid for.
 */
export function useRemovePaidActivatedDrawIdFromUrl() {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    return useCallback((paidActivatedDrawIds) => {
        const activatedDrawId = searchParams.get(ACTIVATED_DRAW_ID_QUERY_PARAM);
        if (activatedDrawId === null || !paidActivatedDrawIds.some((id) => String(id) === activatedDrawId)) {
            return;
        }
        const nextSearchParams = new URLSearchParams(searchParams);
        nextSearchParams.delete(ACTIVATED_DRAW_ID_QUERY_PARAM);
        const query = nextSearchParams.toString();
        router.replace(query ? `${pathname}?${query}` : pathname, { scroll: false });
    }, [pathname, router, searchParams]);
}
//# sourceMappingURL=useRemovePaidActivatedDrawIdFromUrl.js.map